import { api, saveAdminSession } from '../api.js';
import LoginForm from './LoginForm.jsx';

export default function AdminLogin({ onLogin }) {
  return (
    <LoginForm
      title="Admin Sign in"
      helpText="Enter the admin credentials provided by IBMA."
      loginFn={(u, p) => api.adminLogin(u, p)}
      saveSessionFn={saveAdminSession}
      onLogin={onLogin}
    />
  );
}
